import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import St10010View from "../../Views/Stock/ST10010";
import Snackbar from "../../Components/Snackbar";

function ST10010(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());
  const [lanData, setLanData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10010.GetStockList,
        {
          startDate: new Date(startDate),
          endDate: endDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          if (getLanData.length != 0) {
            setRowData([]);
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else if (data.type === "Error") {
          if (getLanData.length != 0) {
            setRowData([]);
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              stocktakingDt: data[i].stocktakingDt,
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              soNo: data[i].soNo,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              whCd: data[i].whCd,
              checkWhCd: data[i].checkWhCd,
              closeYn: data[i].closeYn,
              ckeckQty: data[i].checkQty,
              needQty: data[i].needQty,
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              custNm: data[i].custNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              beforeStockQty: data[i].beforeStockQty,
              itemFormula: data[i].itemFormula,
              soItemAmt:
                data[i].itemVatYn === "Y"
                  ? data[i].ckeckQty * data[i].itemStdAmt * 1.1
                  : data[i].checkQty * data[i].itemStdAmt,
              beforeSoItemAmt:
                data[i].itemVatYn === "Y"
                  ? data[i].beforeStockQty * data[i].itemStdAmt * 1.1
                  : data[i].beforeStockQty * data[i].itemStdAmt,
              lCatego: data[i].lCatego,
              mCatego: data[i].mCatego,
              sCatego: data[i].sCatego,
              itemType: data[i].itemType,
              lotNo: data[i].lotNo,
              whCd: data[i].whCd,
              itemUnit: data[i].itemUnit,
              itemGroup: data[i].itemGroup,
              itemCatego: data[i].itemCatego,
              projectNm: data[i].projectNm,
              personCharg: data[i].personCharg,
              remark: data[i].remark,
              itemStdAmt:
                data[i].itemVatYn === "Y"
                  ? data[i].itemStdAmt * 1.1
                  : data[i].itemStdAmt,
              stockQty: data[i].stockQty,
              stockAddQty: Commons.splitReserveFun(
                data[i].stockQty,
                data[i].itemFormula
              ),

              manuFacDt: data[i].manuFacDt
                ? Commons.DateFormating(data[i].manuFacDt.toString(), 2)
                : "",
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <>
      <St10010View
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        SearchLogic={SearchLogic}
        lanData={lanData}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default ST10010;
